/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, IconButton, Tooltip, Divider, Chip, 
    Table, TableContainer, TableHead, TableBody, TableRow, TableCell, 
    TextField, FormControlLabel, Checkbox } from '@material-ui/core'
import { Edit, Delete, Done, Clear, Add } from '@material-ui/icons'

import { Autocomplete } from '@material-ui/lab'
import Action from '../../../../fluid/Actions/ActionFactory';

import SecureWrapper from "../../../Security/SecureWrapper";
import ErrorMessageAlert from "../../../Utilities/ErrorMessageAlert";

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const privileges = ['READ', 'WRITE', 'EXECUTE', 'DELETE']

const styles = theme => ({

})

class Policy extends React.Component {
    state = {
        policy : null,
        selected_type : null,
        selected_instance : null,
        types : [],
        instances : [],
        loading_types : false,
        loading_instances : false
    }

    componentDidMount () {
        console.log("Policy : ", this.props.policy)
        const clone = require('rfdc')()
        let policy = clone(this.props.policy)
        console.log("Loaded Policy : ", policy)
        this.setState({...this.state, policy : policy})
    }

    componentDidUpdate (prevProps) {
        var equal = require('deep-equal')
        console.log("Policy in state : ", this.state.policy)
        console.log("Policy in props : ", this.props.policy)
        console.log("Policy in previous props : ", prevProps.policy)
        console.log("Policy Updated : ", !equal(prevProps.policy.name, this.props.policy.name))
        // if (!equal(prevProps.policy, this.props.policy)) {
        //     this.setState({...this.state, policy : this.props.policy}, () => console.log("Policy after state update: ", this.state.policy))
        // }
        if (this.props.policy.name === "" && prevProps.policy.name !== "") {
            if (this.props.new_policy) {
                this.setState({
                    ...this.state,
                    policy : this.props.policy
                })
            }
        }
    }

    renderPolicyDetails = () => {
        if (this.props.policy === null) {
            return (
                <Paper square style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography variant = 'caption' color = 'textSecondary'>Select a policy to see the details.</Typography>
                </Paper>
            )
        } else {
            if (this.props.edit) {
                if (this.state.policy !== null) {
                    return this.renderPolicyEditor()
                }
            } else {
                return this.renderPolicyView()
            }
        } 
    }

    renderPolicyView = () => {
        return (
            <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'column'}}>
                <Paper square style = {{width : '100%', height : '35%', padding : '20px', display : 'flex', flexDirection : 'column',  overflow: 'auto'}}>
                    <div style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center' }}>
                    <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/policy/{name}",
                        method : "DELETE",
                        operands : [{
                            attrName: "name",
                            value : this.state.policy
                          }]
                      }}
                    > 
                        <Tooltip title = "Delete Policy">
                            <IconButton color = 'secondary' onClick = {() => this.props.delete_policy(this.state.policy)}>
                                <Delete/>
                            </IconButton>
                        </Tooltip>
                        </SecureWrapper>
                        <SecureWrapper
                            access_object = {{
                                operation : "/sainapse/policy/{name}",
                                method : "PUT",
                                operands : [{
                                    attrName: "name",
                                    value : this.state.policy
                                  }]
                            }}
                            > 
                            <Tooltip title = "Edit Policy">
                                <IconButton color = 'primary' onClick = {() => this.props.toggle_edit_policy(!this.props.edit)}>
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                        </SecureWrapper>
                    </div>
                    <div>
                        <Typography variant = 'caption' color = 'primary'>Name</Typography>
                        <Typography variant = 'h6' >{this.props.policy.name}</Typography>
                    </div>
                    <Divider/>
                    <div style = {{marginTop: '10px', flexGrow : 1}}>
                        <Typography variant = 'caption' color = 'primary'>Description</Typography>
                        <div style = {{width : '100%', overflow : 'auto'}}>
                            <Typography variant = 'body2' >{this.props.policy.description !== null ? this.props.policy.description : "Not Available"}</Typography>
                        </div>
                    </div>
                    <Divider/>
                </Paper>
                <Paper square style = {{marginTop : '10px', width : '100%', padding : '20px', display:'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Allowed Privileges</Typography>
                    {this.props.policy.privileges.map((privilege) => {
                        return (
                            <Chip
                                style = {{marginRight : '10px'}}
                                icon = {<Done fontSize = 'small'/>}
                                color = 'primary'
                                label = {privilege}
                            />
                        )
                    })}
                </Paper>
                <Paper square style = {{marginTop: '10px', width : '100%', padding : '20px', flexGrow : 1, overflow : 'auto'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Assets Applied</Typography>
                    <TableContainer style = {{maxHeight : '80%', marginTop : '10px'}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Instance</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.policy.assets.map(asset => {
                                    return (
                                        <TableRow>
                                            <TableCell>{asset.type}</TableCell>
                                            <TableCell>{asset.instance}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>
        )
    }

    renderPolicyEditor = () => {
        return (
            <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'column'}}>
                <Paper square style = {{width : '100%', height : '35%', padding : '20px', display : 'flex', flexDirection : 'column',  overflow: 'auto'}}>
                    <div style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center' }}>
                        <Tooltip title = "Cancel">
                            <IconButton color = 'secondary' onClick = {() => {
                                const clone = require('rfdc')()
                                let policy = clone(this.props.policy)
                                console.log("Canceled Policy Editing - Original: ", policy)
                                this.setState({...this.state, policy : policy}, () => {
                                    this.props.toggle_edit_policy(false)
                                    console.log("Canceled Policy Editing : ", this.state.policy)
                                })
                            }}>
                                <Clear/>
                            </IconButton>
                        </Tooltip>
                        <SecureWrapper
                                access_object = {{
                                    operation : "/sainapse/policy/{name}",
                                    method : "PUT",
                                    operands : [
                                    {
                                        attrName: "name",
                                        value : this.state.policy
                                    }]
                                }}
                                >
                                <Tooltip title = "Submit Policy">
                                    <IconButton color = 'primary' onClick = {() => {
                                        console.log("Policy Type : ", this.props.policy.name)
                                        this.props.submit_policy(this.props.new_policy ? 'new' : 'update', this.state.policy)
                                    }}>
                                        <Done/>
                                    </IconButton>
                                </Tooltip>
                        </SecureWrapper>
                        {this.props.error === true && (
                            <ErrorMessageAlert
                                open={this.props.error}
                                handleClose={this.props.handleErrorClose}
                                errorInfo={this.props.error_message}
                            />
                        )}
                    </div>
                    <div>
                        <TextField
                            label = "Name"
                            value = {this.state.policy.name}
                            helperText = "The policy name should be unique."
                            onChange = {(event) => {
                                event.preventDefault();
                                let policy = this.props.policy
                                policy.name = event.target.value
                                this.setState({...this.state, policy : policy})
                            }}
                            variant = 'standard'
                            fullWidth
                            disabled = {!this.props.new_policy}
                        />
                        <TextField
                            style = {{marginTop: '10px'}}
                            label = "Description"
                            helperText = "Policy Description."
                            value = {this.state.policy.description}
                            onChange = {(event) => {
                                let policy = this.props.policy
                                policy.description = event.target.value
                                this.setState({...this.state, policy : policy})
                            }}
                            variant = 'standard'
                            fullWidth
                            multiline
                            rows = {5}
                        />
                    </div>
                </Paper>
                <Paper square style = {{marginTop : '10px', width : '100%', padding : '20px', display:'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Allowed Privileges</Typography>
                    {privileges.map(privilege => {
                        return (
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={this.state.policy.privileges.includes(privilege)} 
                                        onChange={() => this.togglePrivelege(privilege, this.props.new_policy ? 'new' : 'update')} 
                                        name={privilege} color = 'primary'
                                    />}
                                label={privilege}
                            />
                        )
                    })}
                </Paper>
                <Paper square style = {{marginTop: '10px', width : '100%', padding : '20px', flexGrow : 1, overflow : 'auto'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Assets Applied</Typography>
                    <TableContainer style = {{maxHeight : '80%', marginTop : '10px'}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Instance</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Autocomplete
                                            id = 'select_type'
                                            size = 'small'
                                            options = {this.state.types}
                                            getOptionLabel={(option) => option}
                                            value = {this.state.selected_type}
                                            onChange={(event, newValue) => {
                                                this.setState({...this.state, selected_type : newValue, selected_instance : null, instances : []})
                                            }}
                                            openOnFocus
                                            loading = {this.state.loading_types}
                                            onOpen = {this.getTypes}
                                            renderInput={(params) => <TextField {...params} label="Select Type" variant="outlined"/>}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Autocomplete
                                            id = 'select_type'
                                            size = 'small'
                                            options = {this.state.instances}
                                            getOptionLabel={(option) => option}
                                            value = {this.state.selected_instance}
                                            onChange={(event, newValue) => {
                                                this.setState({...this.state, selected_instance : newValue})
                                            }}
                                            openOnFocus
                                            disabled = {this.state.selected_type === null}
                                            loading = {this.state.loading_instances}
                                            onOpen = {this.getInstances}
                                            renderInput={(params) => <TextField {...params} label="Select Instance" variant="outlined"/>}
                                        />
                                    </TableCell>
                                    <TableCell>
                                    <SecureWrapper
                                            access_object = {{
                                                operation : "/sainapse/asset/type",
                                                method : "GET",
                                                operands : []
                                            }}
                                            >
                                            <Tooltip title = "Add">
                                                <IconButton 
                                                    size = 'small'
                                                    color = 'primary'
                                                    disabled = {this.state.selected_type === null && this.state.selected_instance === null}
                                                    onClick = {this.addSelectedAsset}
                                                >
                                                    <Add/>
                                                </IconButton>
                                            </Tooltip>
                                        </SecureWrapper>
                                    </TableCell>
                                </TableRow>
                                {this.state.policy.assets.map((asset, i) => {
                                    return (
                                        <TableRow>
                                            <TableCell>{asset.type}</TableCell>
                                            <TableCell>{asset.instance}</TableCell>
                                            <TableCell>
                                                <IconButton size = 'small' color ='secondary' onClick = {() => this.deleteAsset(asset)}>
                                                    <Delete/>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>
        )
    }

    getTypes = () => {
        this.setState({...this.state, loading_types : true}, () => {
            Action('http_request', {
                url : "/sainapse/asset/type",
                method : "get",
                data : {}
            }).then(res => {
                let types = res.data.result.map(type => type.name)
                this.setState({...this.state, loading_types : false, types : types})
            })
        })
    }

    getInstances = () => {
        this.setState({...this.state, loading_instances : true}, () => {
            Action('http_request', {
                url : "/sainapse/asset/instance/" + this.state.selected_type,
                method : "get",
                data : {}
            }).then(res => {
                let instances = res.data.result.map(instance => instance.name)
                this.setState({...this.state, loading_instances : false, instances : instances})
            })
        })
    }

    addSelectedAsset = () => {
        let policy = this.state.policy
        let asset = {
            type : this.state.selected_type,
            instance : this.state.selected_instance
        }

        policy.assets.push(asset)

        this.setState({...this.state, policy : policy, selected_type : null, selected_instance : null, types : [], instances : []})
    }

    deleteAsset = (asset) => {
        let policy = this.state.policy

        let asset_index = policy.assets.findIndex(ass => ass.type === asset.type && ass.instance === asset.instance)
        policy.assets.splice(asset_index, 1)

        this.setState({...this.state, policy : policy})
    }

    togglePrivelege = (privilege, type) => {
        console.log("Toggling Privilege : ", privilege)
        let policy;
        const clone = require('rfdc')()
        if(type === 'new')
        {
            policy = this.props.policy
        }
        else{
            
            policy = this.props.edit ? this.props.policy : clone(this.props.policy)
        }
        console.log("Privileges :", policy.privileges)
        let privilege_index = policy.privileges.indexOf(privilege)
        console.log("Privilege Index: ", privilege_index)
        if (privilege_index === -1) {
            policy.privileges.push(privilege)
            this.setState({...this.state, policy : policy})
        } else {
            policy.privileges.splice(privilege_index, 1)
            this.setState({...this.state, policy : policy})
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderPolicyDetails()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Policy);